import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Modal, Paper } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import React, { useEffect, useRef } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  style?: React.CSSProperties;
  hideClose?: boolean;
  fullWidth?: boolean;
  hideBack?: boolean;
  onBack?: () => void;
  desabilitarScroll?: boolean;
  children: React.ReactNode;
};

const EdModal: React.FC<Props> = (props) => {
  const {
    children,
    open,
    onClose,
    style,
    hideClose,
    fullWidth,
    onBack,
    hideBack,
    desabilitarScroll,
    ...other
  } = props;

  const openRef = useRef(false);

  const BUTTON_SIZE = 50;

  openRef.current = open;
  useEffect(() => {
    openRef.current = open;
  }, [open]);

  useEffect(() => {
    const callback = () => {
      onClose();
    };
    document.addEventListener('backbutton', callback);
    return () => {
      document.removeEventListener('backbutton', callback);
    };
  }, []);

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 'env(safe-area-inset-top, 0px)'
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      {...other}
      className={'EdModal'}
    >
      <Fade in={open}>
        <Paper
          style={{
            minWidth: 'min(100vw, 500px)',
            maxWidth: fullWidth ? '100%' : 'min(100vw, 800px)',
            position: 'relative',
            paddingTop: !hideBack ? BUTTON_SIZE : 0,

            ...style,

            maxHeight: 'calc(100% - 50px)',
            overflowY: desabilitarScroll ? 'hidden' : 'auto'
          }}
        >
          {onBack && !hideBack && (
            <IconButton
              onClick={() => {
                if (onBack) {
                  onBack();
                }
              }}
              style={{
                height: BUTTON_SIZE,
                width: BUTTON_SIZE,
                position: 'absolute',
                top: 0,
                left: 0
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}

          {!hideClose && (
            <IconButton
              onClick={() => onClose()}
              style={{
                height: BUTTON_SIZE,
                width: BUTTON_SIZE,
                position: 'absolute',
                top: 0,
                right: 0
              }}
            >
              <CloseIcon />
            </IconButton>
          )}

          <div
            //mecher neste css para ajustar as telas e os botões inferiores
            style={{
              overflow: desabilitarScroll ? 'hidden' : 'auto',
              paddingTop: fullWidth ? 0 : 10
            }}
          >
            <div
              style={{
                paddingLeft: fullWidth ? 0 : 20,
                paddingRight: fullWidth ? 0 : 20,
                paddingBottom: fullWidth ? 0 : 20
              }}
            >
              {children}
            </div>
          </div>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default EdModal;
